import types from '@/vuex/relatorios/mutations-types.js'

const mutations = {
  [types.SET_LISTA_UNIDADES_PROCEDENCIA]: (state, payload) => {
    state.listaUnidadesProcedencia = payload.listaUnidadesProcedencia
  }
}

export default mutations
